"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StatusIndicatorIcon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _layout = require("../layout");

var _propTypes = require("../prop-types");

var _context = require("../context");

var _utils = require("../utils");

var _statusIndicatorConstants = require("./statusIndicatorConstants");

var _StatusIndicatorText = _interopRequireDefault(require("./StatusIndicatorText"));

var _sizeConfiguration = require("./sizeConfiguration");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

// Align to the center of the first line of text by making the height of the
// wrapper equal to the line height of the text, and centering the icon vertically
// in the wrapper.
var StatusIndicatorIconWrapper = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterProps)(['fontSize'])
})(function (_ref) {
  var theme = _ref.theme,
      fontSize = _ref.fontSize;
  return {
    display: 'flex',
    alignItems: 'center',
    // Line height is specified as unitless so it must be multiplied by the font size
    // to get the absolute value.
    height: "calc(".concat(theme.selectors.lineHeight(fontSize), " * ").concat(theme.selectors.fontSize(fontSize), ")")
  };
});

var StatusIndicatorIcon = function StatusIndicatorIcon(_ref2) {
  var status = _ref2.status,
      iconColorProp = _ref2.iconColor,
      iconAltText = _ref2.iconAltText,
      iconAriaHidden = _ref2.iconAriaHidden,
      size = _ref2.size;
  var iconComponent = _sizeConfiguration.iconComponents[size][status];
  var iconColor = !!iconColorProp ? {
    color: iconColorProp
  } : {};

  if (!iconComponent) {
    return null;
  }

  var titleProp = iconAltText === undefined ? {} : {
    title: iconAltText
  };
  return (0, _core.jsx)(StatusIndicatorIconWrapper, _sizeConfiguration.textSizeConstants[size], iconComponent((0, _objectSpread2.default)({}, titleProp, iconColor, {
    'aria-hidden': iconAriaHidden
  })));
};

exports.StatusIndicatorIcon = StatusIndicatorIcon;
var StatusIndicatorDefaultProps = {
  size: 's',
  colorScheme: _interfaces.StatusIndicatorColorScheme.Default
};

var StatusIndicator = function StatusIndicator(_ref3) {
  var status = _ref3.status,
      messageText = _ref3.messageText,
      iconAltText = _ref3.iconAltText,
      iconAriaHidden = _ref3.iconAriaHidden,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? StatusIndicatorDefaultProps.size : _ref3$size,
      _ref3$colorScheme = _ref3.colorScheme,
      colorScheme = _ref3$colorScheme === void 0 ? StatusIndicatorDefaultProps.colorScheme : _ref3$colorScheme,
      width = _ref3.width,
      id = _ref3.id;
  return (0, _core.jsx)(_layout.Row, {
    "data-test-component": "StatusIndicator",
    alignItems: "flex-start",
    minWidth: _statusIndicatorConstants.STATUS_INDICATOR_MIN_WIDTH,
    width: width,
    gridGap: _statusIndicatorConstants.STATUS_INDICATOR_GAP,
    id: id
  }, !!status && status !== _statusIndicatorConstants.STATUS.NEUTRAL && (0, _core.jsx)(StatusIndicatorIcon, {
    size: size,
    status: status,
    iconColor: colorScheme === _interfaces.StatusIndicatorColorScheme.Inverted ? 'neutral0' : undefined,
    iconAltText: iconAltText,
    iconAriaHidden: iconAriaHidden
  }), (0, _core.jsx)(_StatusIndicatorText.default, (0, _extends2.default)({
    color: colorScheme === _interfaces.StatusIndicatorColorScheme.Default ? 'neutral70' : 'neutral0'
  }, _sizeConfiguration.textSizeConstants[size]), messageText));
};

StatusIndicator.defaultProps = (0, _objectSpread2.default)({}, StatusIndicatorDefaultProps);
StatusIndicator.displayName = 'StatusIndicator';
var StatusIndicatorWithDocs = (0, _stencilReactDesc.describe)(StatusIndicator).description('Visual representation of status.');
StatusIndicatorWithDocs.propTypes = {
  status: _stencilReactDesc.PropTypes.oneOf(Object.values(_statusIndicatorConstants.STATUS)).description('Determines which icon is displayed.'),
  iconAltText: _stencilReactDesc.PropTypes.string.description("Hidden text for the icon that is announced by screen readers. If the icon is purely presentational, use 'statusIconAriaHidden' instead."),
  iconAriaHidden: _stencilReactDesc.PropTypes.bool.description('Hides the icon from assistive technology. This does not affect the text displayed next to the icon. It should be set to true if the icon is purely presentational.'),
  colorScheme: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.StatusIndicatorColorScheme)).description('Sets a predefined color scheme to use for the component.'),
  messageText: _stencilReactDesc.PropTypes.string.isRequired.description('Text displayed next to the icon.'),
  size: _stencilReactDesc.PropTypes.oneOf(['s', 'l']).description('The size of the indicator.'),
  width: (0, _propTypes.cssValue)().description("Sets the CSS 'width' property of the indicator."),
  id: _stencilReactDesc.PropTypes.string.description("Sets 'id' for the whole element.")
};
var _default = StatusIndicatorWithDocs;
exports.default = _default;